module.exports = ".d-flex-end {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n\n.margin-right-20 {\n    margin-right: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/add-occasion/add-occasion.component.css
// module id = ./src/app/main-settings/add-occasion/add-occasion.component.css
// module chunks = main